import networkService from '../../../Network/NetworkManager';
import APPURL from '../../../Constants/URLConstants';
import {uuid} from 'uuidv4';

export const onUserSubmit = async ({
  form_state,
  setFormState,
  setIsLoading,
  setCurrentStep,
  setSelectedUser,
}) => {
  try {
    setIsLoading(true);
    const responseJson = await networkService.networkCall(
      `/v1/users/token`,
      'post',
      JSON.stringify({
        user: {
          uuid: uuid(),
          email: form_state?.email,
          first_name: form_state?.first_name,
          last_name: form_state?.last_name,
          username: form_state?.email,
          type: form_state?.type,
        },
      }),
    );
    setSelectedUser(responseJson?.data?.user);

    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
  }
};
